import { useState, useEffect } from "react";
import styles from "./Tutorial.module.css";
import { Modal } from "@shared/ui/Modal/Modal";

// Интерфейс для описания шага туториала
interface TutorialStep {
  title: string;
  targetSelector?: string; // CSS селектор элемента для подсветки
  zIndex?: number; // Z-index для элемента
  tabsType?: number; // Тип вкладки (1 или 2)
}

const ModalTutorial = () => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [accepted, setAccepted] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!isOpen) {
      setCurrentStep(0);
      setAccepted(false);
      // Сбрасываем стили при закрытии туториала
      resetAllHighlights();
    }
  }, [isOpen]);

  // Обновляем выделение элементов при изменении шага
  useEffect(() => {
    if (accepted && currentStep < stepsData.length) {
      // Сбрасываем предыдущие выделения
      resetAllHighlights();

      // Выделяем текущий элемент
      const stepData = stepsData[currentStep];
      if (stepData.targetSelector) {
        highlightElement(stepData.targetSelector, stepData.zIndex || 9999);
      }
    }

    return () => {
      // Очистка при размонтировании
      resetAllHighlights();
    };
  }, [currentStep, accepted]);

  // Функция для выделения элемента
  const highlightElement = (selector: string, zIndex: number) => {
    try {
      const elements = document.querySelectorAll(selector);
      elements.forEach((el) => {
        const element = el as HTMLElement;
        if (element) {
          // Сохраняем оригинальный z-index
          element.dataset.originalZIndex = element.style.zIndex || "";
          element.dataset.tutorialHighlighted = "true";

          // Устанавливаем новый z-index
          element.style.zIndex = zIndex.toString();
        }
      });
    } catch (error) {
      console.error("Error highlighting element:", error);
    }
  };

  // Функция для сброса выделения со всех элементов
  const resetAllHighlights = () => {
    try {
      const highlightedElements = document.querySelectorAll(
        '[data-tutorial-highlighted="true"]'
      );
      highlightedElements.forEach((el) => {
        const element = el as HTMLElement;

        element.style.zIndex = element.dataset.originalZIndex || "";

        delete element.dataset.tutorialHighlighted;
        delete element.dataset.originalZIndex;
      });
    } catch (error) {
      console.error("Error resetting highlights:", error);
    }
  };

  const stepsData: TutorialStep[] = [
    {
      title:
        "Это ПЫЛ — твоя основная валюта на платформе. Сейчас покажу, как её фармить.",
      targetSelector: ".s",
      zIndex: 1000,
      tabsType: 1,
    },
    {
      title:
        "Тут берёшь миссии на следующий матч. Выполняешь миссию — получаешь ПЫЛ",
      targetSelector: ".missions-tab",
      zIndex: 1000,
      tabsType: 2,
    },
    {
      title: "Магазин тут. Накопил ПЫЛ? Меняй на годные скины.",
      targetSelector: ".tabs",
      zIndex: 1000,
      tabsType: 2,
    },
    {
      title:
        "Live Match — открой на телефоне во время игры. Контролируй задачи, смотри прогресс и даже добирай миссии прямо в матче!",
      targetSelector: ".tabs",
      zIndex: 1000,
      tabsType: 2,
    },
    {
      title:
        "Профиль — тут всё про твои деньги, миссии и сколько ты уже поднял ПЫЛа.",
      targetSelector: ".profile-tab",
      zIndex: 1000,
      tabsType: 1,
    },
    {
      title:
        "Топ игроков здесь. Обновляем раз в две недели, лучших по традиции засыпаем ПЫЛом.",
      targetSelector: ".leaderboard",
      zIndex: 1000,
      tabsType: 1,
    },
  ];

  const onClose = () => {
    setIsOpen(false);
  };

  const handleAccept = () => {
    setAccepted(true);
    setCurrentStep(0);
  };

  const handleModalClick = () => {
    if (!accepted) return;

    if (currentStep < stepsData.length) {
      setCurrentStep((prevStep) => prevStep + 1);
    } else {
      onClose();
    }
  };

  const handleCloseClick = () => {
    onClose();
  };

  const getFraseClassName = () => {
    if (currentStep >= stepsData.length) return styles.frase;

    const tabsType = stepsData[currentStep].tabsType;

    if (tabsType === 1) {
      return `${styles.frase}`;
    } else if (tabsType === 2) {
      return `${styles.frase2}`;
    }

    return styles.frase;
  };

  const acceptContent = (
    <div className={styles.acceptContent}>
      <div className={styles.acceptModalContainer}>
        <img src="/tutorial/StartTutorial.svg" className={styles.modalAccept} />
        <img
          src="/tutorial/ButtonTutorial.png"
          className={styles.acceptButton}
          onClick={handleAccept}
        />
      </div>
      <div className={styles.closeButton} onClick={handleCloseClick}>
        Нет, пройду позже
      </div>
    </div>
  );

  const stepContent =
    currentStep < stepsData.length ? (
      <div className={styles.stepContent} onClick={handleModalClick}>
        {/* Добавляем overlay для выделения элементов */}

        {currentStep === 0 && (
          <img className={styles.Pyl} src="/tutorial/Pyl.png" />
        )}
        {currentStep === 1 && (
          <img className={styles.GoonBut} src="/tutorial/GoonBut.png" />
        )}
        {currentStep === 2 && (
          <img className={styles.TabsImg} src="/tutorial/Tab_shop.png" />
        )}
        {currentStep === 3 && (
          <img className={styles.TabsImg} src="/tutorial/Tab-live.png" />
        )}
        {currentStep === 4 && (
          <img className={styles.profile} src="/tutorial/Profile.png" />
        )}
        {currentStep === 5 && (
          <img className={styles.leader} src="/tutorial/Liderboard.png" />
        )}

        <div className={styles.goonFrase}>
          <div className={styles.goon}></div>
          <div className={getFraseClassName()}>
            <p>{stepsData[currentStep].title}</p>
          </div>
        </div>
      </div>
    ) : (
      <div className={styles.stepContent} onClick={handleModalClick}>
        <div className={styles.goonFrase}>
          <div className={styles.goon}></div>
          <div className={styles.frase}>
            Здесь разобрались, так что располагайся и наслаждайся игрой!
          </div>
        </div>
      </div>
    );

  return (
    <>
      <div className={styles.modalButton} onClick={() => setIsOpen(true)}>
        {" "}
      </div>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        mountPoint="modal"
        tutorial={true}
      >
        {!accepted ? acceptContent : stepContent}
      </Modal>
    </>
  );
};

export default ModalTutorial;
